import { useContext } from 'react';
import { CancellationRequestViewContext } from './context';

export const useCancellationRequestView = () => {
  const context = useContext(CancellationRequestViewContext);

  if (!context) throw new Error('useCanellationRequestView must be used within a CanellationRequestViewProvider');

  return context;
};
